import { Theme } from '@user-portal/wikr-components';
import React from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

import { ISkeleton } from './types';

import { SkeletonContainer } from './styled';

import 'react-loading-skeleton/dist/skeleton.css';

const WIDTH = 1000;
const HEIGHT = 1000;

const Skeleton = ({ width, height, borderRadius, mb, marginLeft, marginTop }: ISkeleton) => {
    const theme = useTheme() as Theme;

    return (
        <SkeletonContainer
            width={width}
            height={height}
            dataLocator="SkeletonContainer"
            $mb={mb}
            $marginLeft={marginLeft}
            $marginTop={marginTop}
            $borderRadius={borderRadius || Number(theme['border-radius-medium'])}
        >
            <ContentLoader
                foregroundColor={theme['secondary-default']}
                backgroundColor={theme['surface-hovered']}
                animate
            >
                <rect x={0} y={0} width={WIDTH} height={HEIGHT} />
            </ContentLoader>
        </SkeletonContainer>
    );
};

export default Skeleton;
